module.exports = __webpack_public_path__ + "static/media/chilling.38a84d85.gif";